import type { SyntheticEvent } from 'react';

import type { PhoneCountryOption } from '@/utils/formatters/phoneCountryCode';
import { sanitizeDigits } from '@/utils/formatters/phoneNumberParts';

export const MAX_COMBINED_PHONE_LENGTH = 40;

export const isPureDigits = (value: string): boolean => /^\d+$/.test(value);

export const computeNationalMaxLength = (callingCodeLength: number): number =>
	Math.max(MAX_COMBINED_PHONE_LENGTH - (callingCodeLength + 2), 1);

export const hideBrokenFlag = (e: SyntheticEvent<HTMLImageElement>) => {
	e.currentTarget.style.display = 'none';
};

export const commonPrefixLength = (a: string, b: string): number => {
	let i = 0;
	while (i < a.length && i < b.length && a[i] === b[i]) i++;
	return i;
};

export const commonSuffixLength = (
	a: string,
	b: string,
	maxLen: number
): number => {
	let i = 0;
	while (i < maxLen && a[a.length - 1 - i] === b[b.length - 1 - i]) i++;
	return i;
};

export const remapCursorPosition = (
	raw: string,
	newValue: string,
	cursorPos: number
): number => {
	if (cursorPos >= raw.length) return newValue.length;

	const prefixLen = commonPrefixLength(raw, newValue);
	if (cursorPos <= prefixLen) return cursorPos;

	const maxSuffix = Math.max(
		Math.min(raw.length, newValue.length) - prefixLen,
		0
	);
	const suffixLen = commonSuffixLength(raw, newValue, maxSuffix);
	if (cursorPos >= raw.length - suffixLen) {
		return newValue.length - (raw.length - cursorPos);
	}

	return newValue.length - suffixLen;
};

export const filterCountryOptions = (
	options: PhoneCountryOption[],
	input: string
) => {
	const query = input.trim().toLowerCase();
	if (!query) return options;

	const digits = sanitizeDigits(query);
	return options.filter(
		o =>
			o.name.toLowerCase().includes(query) ||
			(!!digits && o.callingCode.includes(digits))
	);
};
